import TextInput from "../CustomUi/TextInput";
import SelectInput from "../CustomUi/SelectInput";
import { genders } from "../../services/constants";
import CustomButton from "../CustomUi/CustomButton";
import FormNavigationLinks from "../CustomUi/FormNavigationLinks";
import { useNavigate } from "react-router-dom";
import useIcons from "../../hooks/useIcons";
import { HStack, Stack, VStack } from "@chakra-ui/react";
import useThemeColors from "../../hooks/useThemeColors";

interface Props {
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
  errors: any;
  handleNextStep: () => void;
  loading: boolean;
  firstName: string;
  lastName: string;
  email: string;
  gender: number;
  isNextDisabled?: boolean;
}

function PersonalDetailsRegForm({
  handleChange,
  errors,
  handleNextStep,
  loading,
  firstName,
  lastName,
  email,
  gender,
  isNextDisabled = false,
}: Props) {
  const genderCollection = genders.map((g) => ({
    label: g.name,
    value: g.value.toString(),
  }));

  const navigate = useNavigate();
  const icons = useIcons();
  const colors = useThemeColors();
  return (
    <VStack w={"full"}>
      <form onSubmit={handleNextStep} style={{ width: "100%" }}>
        <Stack gap={5}>
          <HStack flexDirection={{ base: "column", md: "row" }} align={{base:"stretch", md:"start"}}>
            <TextInput
              placeholder="First Name *"
              name="firstName"
              value={firstName}
              onChange={handleChange}
              error={errors.firstName}
              required
              invalid={!!errors.firstName}
              useLabelStyle={true}
            />

            <TextInput
              placeholder="Last Name *"
              name="lastName"
              value={lastName}
              onChange={handleChange}
              error={errors.lastName}
              required
              invalid={!!errors.lastName}
            />
          </HStack>

          <SelectInput
            name="gender"
            value={gender.toString()}
            onChange={handleChange}
            error={errors.gender}
            collection={genderCollection}
            placeholder="Select Gender"
          />
          <TextInput
            placeholder="Email *"
            name="email"
            value={email}
            onChange={handleChange}
            error={errors.email}
            required
            invalid={!!errors.email}
            type="email"
          />

          <CustomButton
            type="submit"
            label="Next"
            disabled={loading || isNextDisabled}
            colorPalette={colors.brand.primary}
          />
          <FormNavigationLinks
            links={[
              {
                text: "Already Have an Account?",
                onClick: () => navigate("/auth/login"),
                icon: icons.utility.login,
                isDisabled: loading,
              },
            ]}
          />
        </Stack>
      </form>
    </VStack>
  );
}

export default PersonalDetailsRegForm;
